
interface RecentNewsProps {
  articles: Array<{
    id: string;
    title: string;
    url: string;
    source: string;
    published_at: string;
    created_at: string;
  }>;
}

export default function RecentNews({ articles }: RecentNewsProps) {
  const formatDate = (dateStr: string) => {
    return new Date(dateStr).toLocaleDateString('ko-KR', {
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  };

  return (
    <div className="bg-white rounded-xl border border-gray-100 shadow-sm">
      <div className="p-5 border-b border-gray-100">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-teal-50">
              <i className="ri-newspaper-line text-lg text-teal-600"></i>
            </div>
            <h2 className="text-sm font-bold text-gray-900">최근 수집 뉴스</h2>
          </div>
          <span className="text-xs text-gray-400">{articles.length}건</span>
        </div>
      </div>

      <div className="max-h-[480px] overflow-y-auto">
        {articles.length === 0 ? (
          <div className="p-10 text-center">
            <div className="w-12 h-12 flex items-center justify-center mx-auto mb-3 rounded-full bg-gray-50">
              <i className="ri-newspaper-line text-2xl text-gray-300"></i>
            </div>
            <p className="text-sm text-gray-400">수집된 뉴스가 없습니다</p>
          </div>
        ) : (
          <div className="divide-y divide-gray-50">
            {articles.map((article) => (
              <a
                key={article.id}
                href={article.url}
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="block px-5 py-3.5 hover:bg-gray-50/50 transition-colors cursor-pointer group"
              >
                <div className="flex items-start gap-3">
                  <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-gray-50 flex-shrink-0 mt-0.5 group-hover:bg-teal-50 transition-colors">
                    <i className="ri-link text-base text-gray-400 group-hover:text-teal-500 transition-colors"></i>
                  </div>
                  <div className="flex-1 min-w-0">
                    <p className="text-xs font-semibold text-gray-800 line-clamp-2 group-hover:text-teal-700 transition-colors leading-relaxed">
                      {article.title}
                    </p>
                    <div className="flex items-center gap-2 mt-1.5">
                      <span className="text-xs text-gray-400 bg-gray-50 px-2 py-0.5 rounded-md">{article.source}</span>
                      <span className="text-xs text-gray-300">{formatDate(article.published_at)}</span>
                    </div>
                  </div>
                  <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 opacity-0 group-hover:opacity-100 transition-opacity">
                    <i className="ri-external-link-line text-sm text-gray-400"></i>
                  </div>
                </div>
              </a>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
